import React, { useMemo, useState } from "react";
import { getName } from "country-list";
import AudioPlayer from "./AudioPlayer";
import { useSelector } from "react-redux";
import { audioVoiceTypes, subSidebar } from "./VoiceOptions";

const VoiceOptionCard = ({
  name,
  id,
  gender,
  country,
  onVoiceSelected,
  previewUrl,
  currentPlayingVoice,
  setCurrentPlayingVoice,
}) => {
  const { audioSubTab } = useSelector((state) => state.ui);
  const isElevenLabsTabSelected = useMemo(
    () => subSidebar[audioSubTab]?.name === audioVoiceTypes.NEW,
    [audioSubTab]
  );

  return (
    <div className=" rounded-lg bg-voice-card p-2">
      <p className={"text-sm"}>
        {" "}
        <span
          className={`${!country ? "" : `fi fi${country.toLowerCase()} w-6`}`}
        ></span>{" "}
        {name}
      </p>
      <p className={`text-gray-800 text-xs font-thin mt-1`}>{gender}</p>
      {country && (
        <p className={`text-gray-800 text-xs font-thin mt-1`}>
          {getName(country.slice(1))}
        </p>
      )}
      <div
        className={`flex justify-between items-center mt-2 
        `}
      >
        {previewUrl && (
          <AudioPlayer
            id={id}
            thirdParty={isElevenLabsTabSelected}
            src={previewUrl}
            autoFetch={false}
            btnClassName="!p-2 text-xs"
            setCurrentPlayingVoice={setCurrentPlayingVoice}
            currentPlayingVoice={currentPlayingVoice}
          />
        )}
        <button
          className="bg-transparent border text-gray-600 border-gray-400 text-xs rounded-lg p-2 py-1"
          onClick={() => onVoiceSelected(id)}
        >
          Select
        </button>
      </div>
    </div>
  );
};

const VoiceOptionsList = ({
  country,
  voiceOptions,
  onVoiceSelected,
  voiceOptionClassName,
}) => {
  const [currentPlayingVoice, setCurrentPlayingVoice] = useState(); //id
  console.log("voiceOptionClassName", voiceOptionClassName);
  return (
    <div
      className={`mt-4 grid grid-cols-4 gap-1 w-full h-full max-h-[calc(100%_-_80px)] overflow-auto ${
        voiceOptionClassName ? voiceOptionClassName : ""
      }`}
    >
      {!!voiceOptions &&
        voiceOptions.map((option) => (
          <VoiceOptionCard
            key={option.id}
            {...option}
            country={country}
            onVoiceSelected={onVoiceSelected}
            currentPlayingVoice={currentPlayingVoice}
            setCurrentPlayingVoice={setCurrentPlayingVoice}
          />
        ))}
    </div>
  );
};

export default VoiceOptionsList;
